import { QueryClient } from "@tanstack/react-query";
import { formatViolationsAsErrors } from "./form/services";
import { renderErrorList } from "./form/formik/service";
import { DEFAULT_TOASTER_ERROR_MESSAGE } from "@/config/constants";

let dispatchError = null;

const formatErrorMessage = (error) => {
  const { status, data } = error.response;
  if (status !== 422) {
    return DEFAULT_TOASTER_ERROR_MESSAGE;
  }
  const { violations, "hydra:description": description } = data;
  if (!violations?.length) {
    return description || DEFAULT_TOASTER_ERROR_MESSAGE;
  }
  const errors = formatViolationsAsErrors(violations);
  return Object.keys(errors).length > 1
    ? renderErrorList(errors)
    : Object.values(errors)[0];
};

const handleMutationError = (error) => {
  if (!dispatchError) return;
  dispatchError({
    msg: formatErrorMessage(error),
    type: "error"
  });
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus:
        process.env.REACT_APP_DISABLE_AUTO_REFETCH === "true" ? false : true
    },
    mutations: {
      onError: handleMutationError
    }
  }
});

export const setErrorDispatch = (dispatch) => {
  dispatchError = dispatch;
};
